(function() {
    'use strict';
    angular.module('app')
        .controller('CarriersPostCodeCreateController', function($scope, $location) {
            $scope.countriesForSetup = [
                {
                    name: 'Philippines',
                    code: 'PH'
                },
                {
                    name: 'Australia',
                    code: 'AU'
                },
                {
                    name: 'Taiwan',
                    code: 'TW'
                },
                {
                    name: 'China',
                    code: 'CH'
                },
                {
                    name: 'United States of America',
                    code: 'US'
                }
            ];
            $scope.countriesForUpload = [
                {
                    name: 'Philippines',
                    code: 'PH'
                },
                {
                    name: 'Australia',
                    code: 'AU'
                },
                {
                    name: 'Taiwan',
                    code: 'TW'
                },
                {
                    name: 'China',
                    code: 'CH'
                },
                {
                    name: 'United States of America',
                    code: 'US'
                }
            ];
            $scope.selectCountry = function(country){
                country.isSelected = !country.isSelected;
            };
        });
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/CarriersPostCodeCreateController.js